import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORT_I18N_LANGUAGES, zhHans, en, ja, ko, pt, ptBR, id, ne, es, vi } from '@mygpt/app';

// 改成只支持日语，且不需要跟随浏览器环境语言
// Website 应用固定使用日语
// 不跟随浏览器语言，不读取用户语言设置，始终使用日语
const lang = 'ja';

// 设置文档语言属性
document.documentElement.lang = lang;

i18n
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    lng: 'ja', // 固定使用日语
    load: 'currentOnly',
    supportedLngs: SUPPORT_I18N_LANGUAGES,
    partialBundledLanguages: true,
    fallbackLng: 'ja', // fallback 也使用日语
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      'zh-Hans': {
        translation: zhHans,
      },
      ja: {
        translation: ja,
      },
      ko: {
        translation: ko,
      },
      en: {
        translation: en,
      },
      pt: {
        translation: pt,
      },
      'pt-BR': {
        translation: ptBR,
      },
      id: {
        translation: id,
      },
      ne: {
        translation: ne,
      },
      es: {
        translation: es,
      },
      vi: {
        translation: vi,
      },
    },
  });
